export default function (to, from, savedPosition) {
    const nuxt = window['$nuxt'] || window['__NUXT__'];
    const position = savedPosition || { x: 0, y: 0 };

    return new Promise((resolve) => {
        nuxt.$root.$once('page-after-leave', () => {
            setTimeout(() => {
                nuxt.$nextTick(() => {
                    if (to.hash) {
                        setTimeout(() => {
                            const el = document.querySelector(to.hash);
                            if (el) {
                                el.scrollIntoView({behavior: 'auto'});
                                resolve({x: 0, y: 0});
                                return;
                            }
                        }, 50)
                    }
                    resolve(position);
                });
            }, 50);
        });
    });
}
